import { API_URL } from '~/constants/environment'

import { Api } from '../../utils/api'
import type { Store } from '../@types'

const api = new Api(API_URL, 'customers/web_flows/store')

export const fetchStore = async () => {
  return (await api.get<{ data: Store }>()).data
}
